// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1tvwK","colMin":"styles_colMin__qlb-T"};